'use strict';

angular.module('upAttributes').service('UserAttributes', [
	'FilterType',
	'DisplayType',
	function (FilterType, DisplayType) {
		return function () {
			var attributes = {
				id: {
					title: 'default.id',
					field: 'id',
					type: FilterType.Number,
					displayType: DisplayType.String,
					groupable: false,
					sortable: false,
					selectableColumn: false,
					filterable: false
				},
				name: {
					title: 'default.name',
					field: 'name',
					type: FilterType.String,
					groupable: false,
					sortable: false,
					selectableColumn: false,
					filterable: false
				},
				active: {
					field: 'active',
					type: FilterType.Boolean
				},
				email: {
					field: 'email',
					type: FilterType.String
				},
				ghost: {
					field: 'ghost',
					type: FilterType.Boolean
				},
				userCellPhone: {
					field: 'userCellPhone',
					type: FilterType.String
				},
				crm: {
					field: 'crm',
					type: FilterType.Boolean
				},
				support: {
					field: 'support',
					type: FilterType.Boolean
				}
			};

			return {
				getAll: function () {
					return attributes;
				}
			};
		};
	}
]);
